<template>
    <CompassTooltip
        :content="$t.__('eInvoicing.conformityCheckListHeader.button.tooltip')"
        :disabled="isTooltipDisabled"
        :arrow="false"
    >
        <component
            :is="wrapperComponent"
            :class="itemClass"
            :href="isClickable ? redirect_uri : undefined"
            :data-bot="dataBot"
            @click="!isClickable && $event.preventDefault()"
        >
            <CompassIcon :icon="icon" />
            <span>
                {{ label }}
            </span>
            <CompassFlag v-if="!available" :label="$t.__('common.labels.soon')" size="small" />
        </component>
    </CompassTooltip>
</template>
<script>
export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        available: {
            type: Boolean,
            default: false,
        },
        completed: {
            type: Boolean,
            default: false,
        },
        redirect_uri: {
            type: String,
            default: '',
        },
        dataBot: {
            type: String,
            default: '',
        },
    },
    computed: {
        wrapperComponent() {
            return this.isClickable ? 'a' : 'div';
        },
        itemClass() {
            return {
                'check-list-item': true,
                'typographies-paragraph-medium-semibold': true,
                'check-list-item--is-unavailable': !this.available,
                'check-list-item--is-completed': this.completed,
                'check-list-item--is-clickable': this.isClickable,
            };
        },
        icon() {
            if (this.completed) {
                return 'success-circle';
            }
            return 'circle';
        },
        isClickable() {
            return this.available && this.redirect_uri;
        },
        isTooltipDisabled() {
            return !this.available || !!this.redirect_uri || this.completed;
        },
    },
};
</script>
<style lang="scss" scoped>
.check-list-item {
    align-items: center;
    border: 1px solid var(--colors-common-border-lighter);
    border-radius: var(--spacing-1);
    color: var(--colors-common-text-standard-default);
    display: flex;
    gap: var(--spacing-1);
    padding: var(--spacing-2) var(--spacing-1);
    transition: border-color 100ms cubic-bezier(0, 0, 0.3, 1);

    .compass-tooltip:has(&) {
        display: block;
    }

    :deep(.compass-icon) {
        color: var(--colors-common-text-standard-caption);
        flex-shrink: 0;
    }

    :deep(.compass-flag) {
        flex-shrink: 0;
        margin-left: auto;
    }

    &--is-clickable {
        cursor: pointer;

        &:hover {
            border-color: var(--colors-common-border-default-hover);
        }
    }

    &--is-completed {
        color: var(--colors-common-text-standard-disabled);
        text-decoration: line-through;

        &:hover {
            border-color: var(--colors-common-border-default-hover);
        }

        :deep(.compass-icon) {
            color: var(--colors-common-text-success-default);
        }
    }

    &--is-unavailable {
        cursor: default;

        &:hover {
            border-color: var(--colors-common-border-lighter);
        }
    }
}
</style>
